import topic from '../topic';
export const mdopAPI = {
  getMdops: topic.mdopTopic + '/get_mdncs',
  getMdopById: topic.mdopTopic + '/get_mdnc_by_id',
  addMdop: topic.mdopTopic + '/add_mdnc',
  editMdop: topic.mdopTopic + '/edit_mdnc',
  deleteMdopByIds: topic.mdopTopic + '/delete_mdnc_by_ids'
};
